//user roles (mroService.getRoles) held in redux state
export const USER_ROLES_GET_REQUESTED = "USER_ROLES_GET_REQUESTED";
export const USER_ROLES_GET_SUCCESS = "USER_ROLES_GET_SUCCESS";
export const USER_ROLES_RESET = "USER_ROLES_RESET";
